import { ROLES } from "../../ducks/login";
import Visible from "./Visible";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    children: ownProps.children,
    roles: ownProps.roles,
    userRoles: state.login[ROLES]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Visible);
